module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/1-ecf6410c44e9333162e5aa4b5c21109e.jpg";